<template>
  <div class="withdraw_step2">
    <div class="header_withdraw">
      <p>{{ $t("msg.verify_your_withdraw") }}</p>
    </div>

    <div
      style="
        display: flex;
        justify-content: center;
        margin-bottom: 30px;
        flex-direction: column;
      "
    >
      <div class="withdraw_steps_img">
        <img class="blu_balance_img" src="../../../../assets/images/2.png" />
      </div>
      <div
        style="
          width: 100%;
          display: flex;
          justify-content: center;
          font-size: 9px;
        "
      >
        <div style="width: 60%; display: flex; justify-content: center">
          <span style="margin-left: 10px; color: #02b9a4">{{
            $t("msg.step_amount")
          }}</span>
          <span style="margin-left: 25px; color: #02b9a4">{{
            $t("msg.step_recipient")
          }}</span>
          <span style="margin-left: 25px">{{
            $t("msg.step_verification")
          }}</span>
          <span style="margin-left: 20px">{{
            $t("msg.step_authentication")
          }}</span>
        </div>
      </div>
    </div>

    <div class="redeem_form mw100" v-if="selectedBlue">
      <div class="mw100">
        <p style="margin-bottom: 1rem; text-align: center">
          {{ $t("msg.please_verify_information") }}
        </p>

        <div
          class="column display_values_redeem"
          style="
            border-bottom: none !important;
            border-right: none !important;
            border-left: none !important;
          "
        >
          <p>{{ $t("msg.withdrawing") }}</p>
          <span v-if="previewData.amount">
            {{
              previewData.amount
                | decimalsCrypto(previewData.currency.precision)
            }}
            BLUE
          </span>
        </div>

        <div
          class="column display_values_redeem"
          style="border-bottom: none !important"
        >
          <!-- <p>{{ $t("msg.total_to_receive") }}:</p> -->
          <p>{{ $t("msg.receiving") }}</p>
          <span class="m4_b" v-if="previewData.amount">
            {{ $t("msg.subtotal") }}:
            {{
              previewData.amount
                | decimalsCrypto(previewData.currency.precision)
            }}
            BLUE
          </span>
          <span class="m4_b" v-if="previewData.amount">
            {{ $tc("msg.fee", 1) }}: 0.00 BLUE
          </span>
          <span class="fat" v-if="previewData.amount">
            {{ $t("msg.total") }}:
            {{
              previewData.amount
                | decimalsCrypto(previewData.currency.precision)
            }}
            BLUE
          </span>
        </div>

        <div class="column display_values_redeem">
          <p>{{ $t("msg.send_to_btc_adress") }}:</p>
          <span class="m4_b">
            {{ address }}
          </span>

          <span class="fat"> {{ $t("msg.network") }}: BSC </span>
        </div>

        <div
          class="column"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <button
            class="btn_redeem_back"
            style="background: #e12d2d; width: 100%"
            @click="callBackStep()"
          >
            {{ $t("msg.back") }}
          </button>

          <button
            class="btn_redeem"
            style="width: 100%; margin-right: 0"
            @click="callNextStep()"
          >
            {{ $t("msg.next_step") }}
          </button>
        </div>
      </div>
    </div>

    <div class="redeem_form mw100" v-else>
      <div class="mw100">
        <p style="margin-bottom: 1rem; text-align: center">
          {{ $t("msg.please_verify_information") }}
        </p>

        <div
          class="column display_values_redeem"
          style="border-bottom: none !important"
        >
          <p>{{ $t("msg.withdrawing") }}</p>

          <!-- {{previewData}} -->
          <span v-if="previewData.amount">
            {{
              previewData.amount
                | decimalsCrypto(previewData.currency.precision)
            }}
            USDT
          </span>
        </div>

        <!-- {{previewData}} -->
        <div
          class="column display_values_redeem"
          style="border-bottom: none !important"
        >
          <p>{{ $t("msg.receiving") }}</p>
          <span class="m4_b" v-if="previewData.amount">
            {{ $t("msg.subtotal") }}:
            {{
              previewData.amount
                | decimalsCrypto(previewData.currency.precision)
            }}
            USDT
          </span>
          <span class="m4_b" v-if="previewData.amount">
            {{ $tc("msg.fee", 1) }}: {{ feeUsdt }} USDT
          </span>
          <span class="fat" v-if="previewData.amount">
            {{ $t("msg.total") }}:
            {{
              (previewData.amount - feeUsdt)
                | decimalsCrypto(previewData.currency.precision)
            }}
            USDT
          </span>
        </div>

        <div class="column display_values_redeem">
          <p>{{ $t("msg.send_to_btc_adress") }}:</p>
          <span class="m4_b">
            {{ address }}
          </span>
          <span class="fat"> {{ $t("msg.network") }}: TRC20 </span>
        </div>

        <div
          class="column"
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
          "
        >
          <button
            class="btn_redeem_back"
            style="background: #e12d2d; width: 100%"
            @click="callBackStep()"
          >
            {{ $t("msg.back") }}
          </button>

          <button
            class="btn_redeem"
            style="width: 100%; margin-right: 0"
            @click="callNextStep()"
          >
            {{ $t("msg.next_step") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: ["previewData", "address", "externalId", "selectedBlue"],
  created() {},
  mounted() {},
  data: () => ({
    feeRedeem: "",
    feeUsdt: 2,
  }),
  components: {},
  methods: {
    callNextStep() {
      let params = {
        address: this.address,
        amount: this.previewData.amount,
        currency: "BLU",
      };

      this.$emit("callNext", params);
    },

    callBackStep() {
      this.$emit("resetStep");
    },
  },
  computed: {
    ...mapGetters([
      "member",
      "currencies",
      "bluAccount",
      "btcAccount",
      "bluValue",
      "btcValue",
    ]),
  },
  watch: {},
};
</script>




// WEBPACK FOOTER //
// src/components/private/services/withdraw_steps/WithdrawStep2.vue